import React, { useEffect, useState } from 'react'

import useTranslations from '../../../hooks/useTranslations'
import ANTDCard from '../../../shared/antd/ANTDCard'
import { useFormInstanceFn, useWatchFn } from '../../../shared/antd/ANTDForm'
import { apiParams } from '../../../utils'
import { length } from '../../../utils/javascript'
import AddMoreForm from '../../common/presentation/AddMoreForm'
import { getAddressDataListApi, getTagListApi } from '../user.api'

const LocationCollectionCenter = ({ fieldName }) => {
  const { t } = useTranslations()
  const [stateList, setStateList] = useState([])
  const [cityList, setCityList] = useState({})
  const [filteredCityList, setFilteredCityList] = useState({})
  const [channelList, setChannelList] = useState([])
  const form = useFormInstanceFn()
  const locationChannelRequestDtos = useWatchFn([...fieldName], form)

  useEffect(() => {
    getCityAPI({ type: 'STATE' })
    getChannelAPI({ type: 'CHANNEL_NAME' })
  }, [])

  useEffect(() => {
    if (locationChannelRequestDtos?.length > 0) {
      locationChannelRequestDtos.forEach(item => {
        if (item?.stateId && !length(cityList?.[item?.stateId])) {
          getLocationAPI({ type: 'CITY', stateId: item?.stateId })
        }
      })
    }
  }, [locationChannelRequestDtos])

  const getCityAPI = async ({ type }) => {
    const params = apiParams({ params: { type } })
    const response = await getAddressDataListApi({ params })
    if (length(response?.data?.list)) {
      setStateList(response?.data?.list)
    }
  }
  const getLocationAPI = async ({ type, stateId }) => {
    const params = apiParams({ params: { type, parentId: stateId } })
    const response = await getAddressDataListApi({ params })
    if (length(response?.data?.list)) {
      const locationList = response?.data?.list?.map(city => ({
        label: city?.name,
        value: city?.id,
      }))
      setCityList(prev => ({ ...prev, [stateId]: locationList }))
    }
  }

  const getChannelAPI = async ({ type }) => {
    const response = await getTagListApi({ params: { type } })
    if (length(response?.data?.list)) {
      setChannelList(response?.data?.list)
    }
  }

  const selectedLocationIds =
    locationChannelRequestDtos?.map(item => item?.locationId) || []

  const availableCityList = stateId =>
    cityList?.[stateId]?.map(city => ({
      ...city,
      disabled: selectedLocationIds.includes(city.value),
    })) || []

  return (
    <ANTDCard title={t('user_LocationAndChannel')} className="add-user-card">
      <AddMoreForm
        formFieldAttributes={index => {
          const stateId = locationChannelRequestDtos?.[index]?.stateId

          return {
            stateId: {
              label: 'user_State',
              inputType: 'select',
              options: stateList?.map(v => ({
                label: v?.name,
                value: v?.id,
              })),
              required: true,
              md: 8,
              xs: 24,
            },
            locationId: {
              label: 'inv_Location',
              inputType: 'select',
              options: length(filteredCityList?.[stateId])
                ? filteredCityList[stateId]
                : availableCityList(stateId),
              showSearch: true,
              filterOption: false,
              required: true,
              md: 8,
              xs: 24,
              onSearch: value => {
                const filterOption = availableCityList(stateId)?.filter(opt =>
                  opt?.label
                    ?.toLowerCase()
                    ?.includes(value?.trim()?.toLowerCase()),
                )
                setFilteredCityList(prev => ({
                  ...prev,
                  [stateId]: filterOption,
                }))
              },
            },
            channelIds: {
              label: 'user_Channel',
              inputType: 'select',
              mode: 'multiple',
              options: channelList?.map(v => ({
                label: v?.name,
                value: v?.id,
              })),
              required: true,
              md: 8,
              xs: 24,
            },
          }
        }}
        listName={fieldName}
      />
    </ANTDCard>
  )
}

export default LocationCollectionCenter
